import axios from 'axios';
require('dotenv').config()

const apiTarget = `${process.env.REACT_APP_API_URL}/api`

export default axios.create({
    baseURL: apiTarget
});